export default {
  // Accommodation & Child Categories
  ACCOMMODATION: {
    label: 'Accommodation',
  },
  RENT: {
    label: 'Rent',
  },
  HOTELS: {
    label: 'Hotels',
  },
  // end Accommodation & Child Categories
  // Bank Charges & Child Categories
  BANK_CHARGE: {
    label: 'Bank Charges',
  },
  OVERDRAFT: {
    label: 'Overdraft',
  },
  NSF: {
    label: 'NSF',
  },
  INTEREST_PAID: {
    label: 'Interest Paid',
  },
  // end Bank Charges & Child Categories
  ENTERTAINMENT: {
    label: 'Entertainment',
  },
  GAMBLING: {
    label: 'Gambling',
  },
  // Income & Child Categories
  INCOME: {
    label: 'Income',
  },
  REVENUE: {
    label: 'Revenue',
  },
  SALARY: {
    label: 'Salary',
  },
  INTEREST_RECEIVED: {
    label: 'Interest Received',
  },
  RETIREMENT: {
    label: 'Retirement',
  },
  SOCIAL_SECURITY: {
    label: 'Social Security',
  },
  COMMISSION_RECEIVED: {
    label: 'Commission Received',
  },
  // end Income & Child Categories
  INFRASTRUCTURE: {
    label: 'Infrastructure',
  },
  INSURANCE: {
    label: 'Insurance',
  },
  // Investment & Child Categories
  INVESTMENTS: {
    label: 'Investments',
  },
  SAVINGS: {
    label: 'Savings',
  },
  TRADING: {
    label: 'Trading',
  },
  // end Investment & Child Categories
  // Loan & Child Categories
  LOAN: {
    label: 'Loan',
  },
  MORTGAGE: {
    label: 'Mortgage',
  },
  CARD_REPAYMENT: {
    label: 'Card Repayment',
  },
  MCA: {
    label: 'MCA',
  },
  PAYDAY: {
    label: 'Payday',
  },
  AUTO_LOAN: {
    label: 'Auto Loan',
  },
  BUY_NOW_PAY_LATER: {
    label: 'Buy Now Pay Later',
  },
  // end Loan & Child Categories
  PERSONNEL: {
    label: 'Personnel',
  },
  REFUND: {
    label: 'Refund',
  },
  // Retail & Child Categories
  RETAIL: {
    label: 'Retail',
  },
  FOOD_AND_DRINK: {
    label: 'Food & Drink',
  },
  GROCERIES: {
    label: 'Groceries',
  },
  // end Retail & Child Categories
  SELF_TRANSFER: {
    label: 'Self-Transfer',
  },
  TAX: {
    label: 'Tax',
  },
  TRANSPORT: {
    label: 'Transport',
  },
  UTILITIES: {
    label: 'Utilities',
  },
  WITHDRAWAL: {
    label: 'Withdrawal',
  },
};
